import { XStack, type XStackProps, tokens } from "@fhs/ui";
import { withStaticProperties } from "@fhs/utils";
import { StyleSheet } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export type HeaderFrameProps = XStackProps;
function Frame(props: HeaderFrameProps) {
  const safeAreaInsets = useSafeAreaInsets();

  return (
    <XStack
      {...props}
      style={[
        styles.frame,
        {
          paddingTop: safeAreaInsets.top,
          height: 56 + safeAreaInsets.top,
        },
        props.style,
      ]}
    />
  );
}

export type HeaderFrameLeftProps = XStackProps;
function Left(props: HeaderFrameLeftProps) {
  return <XStack {...props} style={[styles.third, styles.left, props.style]} />;
}

export type HeaderFrameMiddleProps = XStackProps;
function Middle(props: HeaderFrameMiddleProps) {
  return <XStack {...props} style={[styles.third, styles.middle, props.style]} />;
}

export type HeaderFrameRightProps = XStackProps;
function Right(props: HeaderFrameRightProps) {
  return <XStack {...props} style={[styles.third, styles.right, props.style]} />;
}

const styles = StyleSheet.create({
  frame: {
    backgroundColor: tokens.colors.$white,
    justifyContent: "space-between",
  },
  third: {
    flexBasis: `${100 / 3}%`,
    alignItems: "center",
  },
  left: {
    justifyContent: "flex-start",
  },
  middle: {
    justifyContent: "center",
  },
  right: {
    justifyContent: "flex-end",
    paddingRight: 16,
  },
});

export const HeaderFrame = withStaticProperties(Frame, {
  Left,
  Middle,
  Right,
});
